export class QualityItem {
    constructor({
          id= null, 
          itemCode= ``, 
          itemName= ``, 
          craftType= ``,
          checkType= ``,
                   
      } = {}) {
      this.id = id;
      this.itemCode = itemCode;
      this.itemName=itemName;
      this.craftType = craftType;
      this.checkType=checkType;
          
    }
  }
  export function gridFields() {
    return Object.freeze([ 
     
        {
            key: 'itemCode',
            label: 'lbl.qualityItemCode',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
          key: 'itemName',
          label: 'lbl.qualityItemName',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'craftType',
          label: 'lbl.qualityItemCraftType',
          sortable: true,
          form: {
            type: 'select',
              options: [    
                  { value: null, text:  ''  },            
                  { value: 'Q', text:  'lbl.qualityItem.pelletizing' },  
                  { value: 'Y', text:  'lbl.qualityItem.smelt' }
              
                                   
                ]     
          }
        },
        {
          key: 'checkType',
          label: 'lbl.qualityItemCheckType',
          sortable: true,
          form: {
            type: 'select',
              options: [    
                  { value: null, text:  ''  },            
                  { value: 'material', text:  'lbl.qualityItem.material' },  
                  { value: 'process', text:  'lbl.qualityItem.process' },
                  { value: 'production', text:  'lbl.qualityItem.production' },
              
                                   
                ]     
          }
        }
       
       
       
       
    ]);
  }
  
  export const fields = Object.freeze(Object.keys(new QualityItem()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.itemCodeFilter',
    'filter.itemNameFilter',
    'filter.craftTypeFilter',
    'filter.checkTypeFilter',
  ];
  export const filter = {
    'itemCodeFilter': "",
    'itemNameFilter': "",
    'craftTypeFilter': "",
    'checkTypeFilter':"",
    
  };